import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Cart = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M7 18.4512C5.9 18.4512 5.01 19.3512 5.01 20.4512C5.01 21.5512 5.9 22.4512 7 22.4512C8.1 22.4512 9 21.5512 9 20.4512C9 19.3512 8.1 18.4512 7 18.4512ZM1 2.45117V4.45117H3L6.6 12.0412L5.25 14.4912C5.09 14.7712 5 15.1012 5 15.4512C5 16.5512 5.9 17.4512 7 17.4512H19V15.4512H7.42C7.28 15.4512 7.17 15.3412 7.17 15.2012L7.2 15.0812L8.1 13.4512H15.55C16.3 13.4512 16.96 13.0412 17.3 12.4212L20.88 5.93117C20.96 5.79117 21 5.62117 21 5.45117C21 4.90117 20.55 4.45117 20 4.45117H5.21L4.27 2.45117H1ZM17 18.4512C15.9 18.4512 15.01 19.3512 15.01 20.4512C15.01 21.5512 15.9 22.4512 17 22.4512C18.1 22.4512 19 21.5512 19 20.4512C19 19.3512 18.1 18.4512 17 18.4512Z"
    />
  </svg>
);
